import { useState, Fragment } from "react";
import { Descriptions, Spin, List, Divider, Space } from "antd";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useRequest } from "ahooks";
import { useSelector } from "react-redux";
import "braft-editor/dist/output.css";
import { message as messageService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";
import MessageIgnoreButton from "./MessageIgnoreButton";
import MessageWaitButton from "./MessageWaitButton";
import MessageReportButton from "./MessageReportButton";
import MessageBackButton from "./MessageBackButton";
import MessagePushButton from "./MessagePushButton";
import styles from "./index.module.less";

function MessageDetail() {
  const { department_name } = useSelector((state) => state.user);
  const [version, setVersion] = useState(Date.now());
  const { messageId } = useParams();
  const auth = useAuthContext();
  const { data, loading } = useRequest(
    () => {
      return messageService.getMessage(messageId, auth.token);
    },
    {
      ready: !!messageId && !!auth,
      refreshDeps: [messageId, version],
    }
  );
  let status = "-";

  if (data?.sendee.id === auth.department_id) {
    status = data?.status_name;
  } else {
    if (data?.status === 0) status = "草稿";
    if (data?.status === 1) status = "已提交";
    if (data?.status === 3 || data?.status === 4 || data?.status === 5)
      status = `已提交`;
    if (data?.status === 2) status = "已提交";
  }
  return (
    <div className={styles.messageDetail}>
      <div className="message-title">信息详情</div>
      <div className="message-body">
        <Spin spinning={loading}>
          <Descriptions
            bordered
            column={2}
            size="middle"
            labelStyle={{ width: 120 }}
            extra={
              data?.sendee.id === auth.department_id && (
                <Space>
                  <MessageWaitButton
                    type="primary"
                    messageId={data?.id}
                    callback={setVersion}
                  />
                  <MessageIgnoreButton
                    type="primary"
                    messageId={data?.id}
                    callback={setVersion}
                  />
                  <MessageReportButton
                    type="primary"
                    token={auth.token}
                    messageId={data?.id}
                    callback={setVersion}
                  />
                  <MessagePushButton
                    type="primary"
                    token={auth.token}
                    messageId={data?.id}
                    callback={setVersion}
                  />
                  <MessageBackButton
                    type="primary"
                    token={auth.token}
                    messageId={data?.id}
                    callback={setVersion}
                  />
                </Space>
              )
            }
          >
            <Descriptions.Item label="类型">
              {data?.type.name}
            </Descriptions.Item>
            {data?.sendee.id === auth.department_id && (
              <Descriptions.Item label="上报单位">
                {data?.sender.name}
              </Descriptions.Item>
            )}
            {data?.sender.id === auth.department_id && (
              <Descriptions.Item label="接收单位" span={2}>
                {data?.sendee.name}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="标题" span={2}>
              {data?.title}
            </Descriptions.Item>
            <Descriptions.Item label="主题" span={2}>
              {data?.subjects.length !== 0 &&
                data?.subjects.map((s) => s.name).join("，")}
            </Descriptions.Item>
            <Descriptions.Item label="内容" span={2}>
              <div
                className="braft-output-content"
                dangerouslySetInnerHTML={{ __html: data?.content }}
              ></div>
            </Descriptions.Item>
            <Descriptions.Item label="附件" span={2}>
              {data?.attachments.length !== 0 && (
                <ol style={{ margin: 0, padding: 0 }}>
                  {data?.attachments.map((a) => (
                    <li key={a.id}>
                      {a.name}{" "}
                      <a
                        href={`/api/polls/message?id=${a.id}&t=${btoa(
                          department_name
                        )}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        下载
                      </a>
                    </li>
                  ))}
                </ol>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="签发领导" span={1}>
              {data?.issuer}
            </Descriptions.Item>
            <Descriptions.Item label="联系人">
              {data?.contacts}
            </Descriptions.Item>
            <Descriptions.Item label="联系电话">
              {data?.contact_number}
            </Descriptions.Item>
            <Descriptions.Item label="报送日期">
              {data && moment(data.published_at).format("YYYY-MM-DD HH:mm")}
            </Descriptions.Item>
            <Descriptions.Item label="状态" span={2}>
              {status}
            </Descriptions.Item>
            {data?.status === 3 && (
              <Descriptions.Item label="退回原因" span={2}>
                {data?.bounce_comment}
              </Descriptions.Item>
            )}
          </Descriptions>
        </Spin>
        {data?.sendee.id === auth.department_id && (
          <Fragment>
            <Divider />
            <List
              size="small"
              header={<div>流转记录</div>}
              bordered
              dataSource={data.records}
              renderItem={(item) => {
                if (item.type === 0) {
                  return (
                    <List.Item>
                      {`【待处理】${item.created_at} ${item.assignee.username}将信息标记为待处理`}
                    </List.Item>
                  );
                } else if (item.type === 1) {
                  return (
                    <List.Item>
                      {`【不予采用】${item.created_at} ${item.assignee.username}将信息标记为不予采用`}
                    </List.Item>
                  );
                } else if (item.type === 2) {
                  return (
                    <List.Item>
                      {`【采用】${item.created_at} ${item.assignee.username}将信息标记为采用`}
                    </List.Item>
                  );
                } else if (item.type === 3) {
                  return (
                    <List.Item>
                      {`【推送】${item.created_at} ${item.assignee.username}将信息推送至${item.acceptor.username}，办理意见为：${item.content}`}
                    </List.Item>
                  );
                } else {
                  return (
                    <List.Item>
                      {`【退件】${item.created_at} ${item.assignee.username}将信息标记为退件`}
                    </List.Item>
                  );
                }
              }}
            />
          </Fragment>
        )}
      </div>
    </div>
  );
}

export default MessageDetail;
